import BaseApiClient from "./base-client";
// API Class
class AiApi extends BaseApiClient {
    QNA_BASE_PATH = "/api/qna";
    AI_INGEST_BASE_PATH = "/api/ai-ingest";
    AI_FEEDBACK_BASE_PATH = "/api/ai-feedback";
    putAiFeedback = async (data) => {
        return this.put(this.AI_FEEDBACK_BASE_PATH, { data });
    };
    qnaFetchResponse = async (responseId, focusStudyId) => {
        const params = focusStudyId ? `?focus_study_id=${focusStudyId}` : "";
        return this.get(`${this.QNA_BASE_PATH}/responses/${responseId}${params}`);
    };
    qnaFetchResponseHistory = async (focusStudyId) => {
        const params = focusStudyId ? `?focus_study_id=${focusStudyId}` : "";
        return this.get(`${this.QNA_BASE_PATH}/responses${params}`);
    };
    qnaFetchFollowUpConversation = async (requestId, focusStudyId) => {
        const params = focusStudyId ? `?focus_study_id=${focusStudyId}` : "";
        return this.get(`${this.QNA_BASE_PATH}/conversations/${requestId}${params}`);
    };
    qnaDeleteResponse = async (responseId) => {
        return this.delete(`${this.QNA_BASE_PATH}/responses/${responseId}`);
    };
    qnaPostQuestion = async (data, abort) => {
        return this.post(this.QNA_BASE_PATH, { data, signal: abort.signal });
    };
    qnaGetConfiguration = async () => {
        return this.get(`${this.QNA_BASE_PATH}/configuration`);
    };
    disableSiteAiFeatureFlag = async () => {
        return this.post("/api/ai-feature/disable");
    };
    disableStudyAiFeatureFlag = async (studyId) => {
        return this.post(`/api/studies/${studyId}/ai-feature/disable`);
    };
    fetchSiteAiFeatureFlag = async () => {
        return this.get("/api/ai-feature");
    };
    fetchStudyAiFeatureFlag = async (studyId) => {
        return this.get(`/api/studies/${studyId}/ai-feature`);
    };
    fetchAiIngestStudyState = async (studyId) => {
        return this.get(`${this.AI_INGEST_BASE_PATH}/state?study_id=${studyId}`);
    };
    fetchEmbeddingBackfillState = async () => {
        return this.get(`${this.AI_INGEST_BASE_PATH}/embedding-backfill-state`);
    };
    postStudyDataForAiProcessing = async (requestDto) => {
        return this.post(`${this.AI_INGEST_BASE_PATH}`, {
            data: {
                ...requestDto,
                include: [
                    {
                        pipeline: "EMBEDDINGS"
                    },
                    {
                        pipeline: "SUMMARY"
                    },
                    {
                        pipeline: "TOPIC_DETECTION"
                    }
                ]
            }
        });
    };
    getAIIngestSiteState = () => {
        return this.get(`${this.AI_INGEST_BASE_PATH}/state`);
    };
    getAIIngestHistory = async () => {
        return this.get(`${this.AI_INGEST_BASE_PATH}/jobs`);
    };
    getAIIngestJobEstimatedDuration = async (data) => {
        return this.post(`${this.AI_INGEST_BASE_PATH}/estimation`, { data });
    };
    createAIIngestJob = (data) => {
        return this.post(`${this.AI_INGEST_BASE_PATH}/jobs`, { data });
    };
    static instance = new AiApi();
}
export default AiApi.instance;
